import angular from 'angular';
import template from './beneficios.component.html';
import './beneficios.repository.js';


angular
    .module('Toke')
    .component('appBeneficios', {
        template,
        bindings: {
            data: '<'
        },
        controller: BeneficiosController
    });

BeneficiosController.$inject = ['beneficiosRepository'];

function BeneficiosController(beneficiosRepository) {
    const vm = this;

    vm.beneficiosData = {};

    vm.$onInit = function () {
        if (vm.data) {
            vm.beneficiosData = vm.data;

        } else {
            beneficiosRepository.getBeneficios().then(res => {
                vm.beneficiosData = res;
            });
        }
    };
}